'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFulcrum = require('@upgrowth/react-fulcrum');

var _lodash = require('lodash');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var supportedProps = [// Html
'min', 'max', 'pattern', 'required', 'step', 'type', 'placeholder', 'disabled'];

exports.default = function (_ref) {
  var name = _ref.name,
      type = _ref.type,
      context = _ref.context;
  var value = context.value,
      path = context.path,
      labels = context.labels,
      _onChange = context.onChange;
  var description = type.description,
      label = type.label,
      _type$defaultValue = type.defaultValue,
      defaultValue = _type$defaultValue === undefined ? "" : _type$defaultValue,
      _type$multiline = type.multiline,
      multiline = _type$multiline === undefined ? false : _type$multiline,
      _type$variant = type.variant,
      variant = _type$variant === undefined ? "primary" : _type$variant;
  value = typeof value === 'string' ? value : defaultValue;
  return _react2.default.createElement('div', {
    className: 'StringEditor variant-' + variant
  }, multiline ? _react2.default.createElement(_reactFulcrum.Textarea, (0, _extends3.default)({
    type: 'text'
  }, (0, _lodash.pick)(type, supportedProps), {
    onChange: function onChange(value) {
      return _onChange(path, value);
    },
    value: value
  })) : _react2.default.createElement(_reactFulcrum.Input, (0, _extends3.default)({
    type: 'text'
  }, (0, _lodash.pick)(type, supportedProps), {
    onChange: function onChange(value) {
      return _onChange(path, value);
    },
    value: value
  })));
};